import ArticlePage from "./ArticlePage";
import { pages, navLinks } from "../data/site";
import {
  breadcrumbSchema,
  buildGraph,
  webpageSchema,
} from "../data/schema";

const SpeakingPage = () => {
  const seo = pages.speaking;
  const schema = buildGraph([
    webpageSchema(seo),
    breadcrumbSchema([
      { name: "Home", path: "/" },
      { name: "Speaking", path: seo.path },
    ]),
  ]);

  return (
    <ArticlePage
      seo={seo}
      schema={schema}
      theme="light"
      bigTitle="TALK"
      heading="Speaking and community — Hareesh Rajendran"
      related={navLinks.filter((link) => link.to !== seo.path)}
    >
      <p>
        Hareesh Rajendran speaks with developer communities in Chennai and
        mentors student hackathons.
      </p>

      <h2>Talks and communities</h2>
      <ul>
        <li>Chennai React</li>
        <li>FOSS United</li>
        <li>JSLovers</li>
        <li>Namma Flutter</li>
        <li>
          Workshop at Chennai Institute of Technology: The Future of DSA in the
          AI Era
        </li>
        <li>Code on JVM meetup: DSA in Production</li>
        <li>Mentorship session with a GitLab Security Engineer</li>
      </ul>

      <h2>Hackathons</h2>
      <ul>
        <li>Jury member at multiple hackathons, including PEC Hacks</li>
        <li>
          Evaluator, Smart India Hackathon internal round, Jeeva College of
          Engineering
        </li>
        <li>Mentor, Hackathon War Room by Code Hunters Academy</li>
      </ul>
    </ArticlePage>
  );
};

export default SpeakingPage;
